import React from 'react';
import { Typography } from '@mui/material';

export const SubSectionTitle = ({ children }: { children: React.ReactNode }) => (
  <Typography sx={{ fontSize: 16, fontWeight: 500, lineHeight: '22px' }}>{children}</Typography>
);
